import axiosInstance from '@/plugins/axios'
const menuPanel = {
  state: {
    menuTabs: [
      { title: '转单订单', key: '1', info: '' },
      { title: '制签订单', key: '2', info: '' },
      { title: '公证订单', key: '3', info: '' },
      { title: '问答消息', key: '4', info: '' },
      { title: '供应商审核', key: '5', info: '' },
      { title: '制签预警', key: '6', info: '' },
    ],
  },
  actions: {
    async UpdateMessageCount({ commit, rootState }) {
      const res = await axiosInstance.get('/additional/admin/messageMenu/getMenuCount')
      const messageTypeMap = res.data
      commit('UPDATE_MENU_INFO', messageTypeMap)
    },
  },
  mutations: {
    UPDATE_MENU_INFO: (state, messageTypeMap) => {
      for (const i in messageTypeMap) {
        if (messageTypeMap[i] === '0') {
          messageTypeMap[i] = ''
        }
      }
      state.menuTabs[0].info = messageTypeMap.unzhuandan
      state.menuTabs[1].info = messageTypeMap.unzhiqian
      state.menuTabs[2].info = messageTypeMap.ungongzheng
      state.menuTabs[3].info = messageTypeMap.unwenda
      state.menuTabs[4].info = messageTypeMap.ungongyingshang
      state.menuTabs[5].info = messageTypeMap.unyujing
    },
  },
}
export default menuPanel
